import SpzLogo from "@/assets/logo-spz.svg";
import auth0Client from "@/auth0";
import envService from "@/env.service";
import { Button } from "@spz/ui/components/button";
import { Typography } from "@spz/ui/components/typography";
import { useTranslation } from "react-i18next";

function logout() {
  auth0Client.logout({
    logoutParams: {
      returnTo: envService.env.auth0.logoutTo,
    },
  });
}

export const AccessDeniedPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="h-screen">
      <div className="flex items-center justify-center h-full bg-gray-50 rounded-md overflow-auto">
        <div className="flex flex-col w-full max-w-[534px] mx-6 gap-6">
          <div>
            <img src={SpzLogo} alt="SpzLogo" className="w-[172px]" />
          </div>
          <div className="gap-2">
            <Typography variant="h3">{t("access_denied_title")}</Typography>

            <Typography className="text-gray-700 text-subtitle">
              {t("access_denied_description")}
            </Typography>
          </div>
          <div className="gap-4 flex flex-col mb-6">
            <Button type="button" variant="secondary" onClick={logout}>
              {t("logout")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
